import { render, staticRenderFns } from "./chaoshi.vue?vue&type=template&id=40b76c40&scoped=true"
import script from "./chaoshi.vue?vue&type=script&lang=js"
export * from "./chaoshi.vue?vue&type=script&lang=js"
import style0 from "./chaoshi.vue?vue&type=style&index=0&id=40b76c40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b76c40",
  null
  
)

export default component.exports